export var ActionSide = /*#__PURE__*/function (ActionSide) {
  ActionSide["AFTER"] = "after";
  ActionSide["BEFORE"] = "before";
  ActionSide["INSIDE"] = "inside";
  return ActionSide;
}({});
export var BlockSide = /*#__PURE__*/function (BlockSide) {
  BlockSide["BOTTOM"] = "bottom";
  BlockSide["LEFT"] = "left";
  BlockSide["RIGHT"] = "right";
  BlockSide["TOP"] = "top";
  return BlockSide;
}({});
export var IndentType = /*#__PURE__*/function (IndentType) {
  IndentType["MARGIN"] = "margin";
  IndentType["PADDING"] = "padding";
  return IndentType;
}({});